export var dataHooks = {
  secondaryMediaImageChildrenContainer: 'secondary-media-image-children-container'
};